"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddFeeController = /** @class */ (function () {
    function AddFeeController($state, UsersModel, FlashService) {
        this.$state = $state;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.inactivate_student = true;
    }
    AddFeeController.prototype.addFee = function () {
        var _this = this;
        this.submitted = true;
        var data = {
            id: this.student.id,
            amount: this.amount * 100,
            inactivate_student: this.inactivate_student,
            notes: this.notes,
        };
        this.UsersModel.addStudentFee(this.student.id, data)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.submitted = false;
            response.fee.status = "Unpaid";
            _this.fees.push(response.fee);
            _this.fee = {};
            if (_this.inactivate_student === true) {
                _this.$state.go("drivecoach.admin.students.view", { userId: _this.student.id }, { reload: true });
            }
        })
            .catch(function (response) {
            _this.submitted = false;
        });
    };
    return AddFeeController;
}());
AddFeeController.$inject = ["$state", "UsersModel", "FlashService"];
exports.default = AddFeeController;
